module.exports = __webpack_public_path__ + "img/file.0e06e144.svg";